function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import { LANG } from '../../utils/constant';
import BreadCrumbShop from '../BreadCrumbShop';
import PropTypes from 'prop-types';
import SingleItem from '../SingleItem';
import { API_URL } from '../../utils/constant';
import Pagination from '../Pagination';
import Loader from '../Loader';
import { objectifyParameters, parametizeURL, translate, translateFieldName, removeKeyValueFromObject, assetPath, getNewURL } from '../../utils/helpers';
import ShopHeaderFilters from '../ShopHeaderFilters';
import Sidebar from '../Sidebar';
import ShopMetaTags from '../meta-tags/ShopMetaTags';
import AddCartModal from '../AddCartModal';
import _orderBy from 'lodash/orderBy';
import _deburr from 'lodash/deburr';
import _difference from 'lodash/difference';
import _trimEnd from 'lodash/trimEnd';
import _isNaN from 'lodash/isNaN';
import SingleCategoryItem from '../SingleCategoryItem';
import { Services } from '../../utils/Services';
import { Redirect } from 'react-router';

var ShopPage = /*#__PURE__*/function (_Component) {
  _inherits(ShopPage, _Component);

  var _super = _createSuper(ShopPage);

  function ShopPage(props) {
    var _this;

    _classCallCheck(this, ShopPage);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "fetchFamily", function () {
      _this.objectifiedParameters = objectifyParameters(_this.props.match.params);
      var families = _this.objectifiedParameters.families;

      if (families !== undefined && families.length == 1) {
        var familyId = _this.objectifiedParameters.families[0];
        Services.fetchFamily(familyId, _this.getFamilyNonce, _this.getFamilyUrl).then(function (family) {
          if (_this._isMounted) {
            _this.setState({
              family: family.data
            });
          }
        });
      } else {
        _this.setState({
          family: null
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "fetchProducts", function () {
      _this.setState({
        loadingProduct: true
      });

      var parameters = parametizeURL(objectifyParameters(_this.props.match.params));

      if (parameters === null) {
        _this.props.history.push('/page/categories');

        return;
      }

      var url = API_URL + '/products.json' + parameters + '&supplier_ids[]=1';
      var sap_id = document.querySelector('body').getAttribute('sap-id');

      if (sap_id) {
        url = url + '&sap_id=' + sap_id;
      }

      fetch(url, {
        headers: {
          'Content-Type': 'application/json'
        },
        mode: 'cors'
      }).then(function (data) {
        return data.json();
      }).then(function (data) {
        if (!data.error) {
          if (_this._isMounted) {
            _this.setState({
              categories: data.categories,
              search: _this.objectifiedParameters.search || null,
              loadingProduct: false
            });

            if (_this.displayProducts) {
              _this.setState({
                products: data.products,
                pagination: data.pagination
              });
            } else {
              _this.setState({
                products: [],
                pagination: {}
              });
            }
          }
        } else {
          _this.props.history.push('/404');
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "fetchCategories", function () {
      Services.fetchCategories().then(function (_categoriesData) {
        if (_this._isMounted) {
          var categoriesData = {
            categories: [],
            subCategories: [],
            subSubCategories: []
          };

          _categoriesData.forEach(function (category, index) {
            categoriesData.categories.push(category);
            category.sub_categories.forEach(function (subCategory, _index) {
              categoriesData.subCategories.push(subCategory);
              subCategory.sub_sub_categories.forEach(function (subSubCategory) {
                categoriesData.subSubCategories.push(subSubCategory);
              });
              delete categoriesData.subCategories[_index].sub_sub_categories;
            });
            delete categoriesData.categories[index].sub_categories;
          });

          delete categoriesData.subCategories.sub_sub_categories;

          _this.setState({
            categoriesData: categoriesData,
            categoriesLoaded: true
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "fetchCertifications", function () {
      var parameters = objectifyParameters(_this.props.match.params);
      var _parameters = parameters;
      parameters = removeKeyValueFromObject(parameters, 'order', 'display', 'certifications');
      parameters = parametizeURL(parameters);
      var url = API_URL + '/products/certifications.json' + parameters;

      if (parameters !== null) {
        fetch(url, {
          headers: {
            'Content-Type': 'application/json'
          },
          mode: 'cors'
        }).then(function (data) {
          return data.json();
        }).then(function (certifications) {
          if (certifications.length > 0) {
            if (_parameters.certifications) {
              _difference(_parameters.certifications.map(Number), certifications.map(function (certification) {
                return certification.id;
              })).forEach(function (certificationId) {
                if (!_isNaN(certificationId)) {
                  var _url = API_URL + '/certifications/' + certificationId + '.json';

                  fetch(_url, {
                    headers: {
                      'Content-Type': 'application/json'
                    },
                    mode: 'cors'
                  }).then(function (_data) {
                    return _data.json();
                  }).then(function (_certification) {
                    if (_certification.status === 404) {// this.props.history.push('/404')
                    }

                    certifications.push(_certification);

                    if (_this._isMounted) {
                      _this.setState({
                        certifications: certifications
                      });
                    }
                  });
                }
              });
            }
          }

          if (_this._isMounted) {
            _this.setState({
              certifications: certifications
            });
          }
        });
      } else {
        _this.setState({
          certifications: []
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "fetchFamilies", function () {
      Services.fetchFamiliesForSidebar(_this.props.match.params).then(function (families) {
        if (_this._isMounted) {
          _this.setState({
            families: families
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setActiveProduct", function (activeProduct) {
      _this.setState({
        activeProduct: activeProduct,
        activeBackDrop: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function () {
      _this.setState({
        activeBackDrop: false
      });

      window.setTimeout(function () {
        $('#ModalAddToCart').modal('hide');
      }, 800);
    });

    _defineProperty(_assertThisInitialized(_this), "closeModalOut", function (e) {
      if (e.target.id === 'ModalAddToCart') {
        _this.setState({
          activeBackDrop: false
        });

        $('#ModalAddToCart').modal('hide');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "orderByName", function (categories) {
      return _orderBy(categories, [function (category) {
        return _deburr(category[translateFieldName('name')].toLowerCase());
      }]);
    });

    _defineProperty(_assertThisInitialized(_this), "getSubSubCategoryString", function (categoryId, subCategoryId) {
      var subSubCategoryId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      return _trimEnd([categoryId, subCategoryId, subSubCategoryId].join('+'), '+');
    });

    _defineProperty(_assertThisInitialized(_this), "getResultIcon", function () {
      return document.querySelector('#shop-page').getAttribute('no-result');
    });

    _defineProperty(_assertThisInitialized(_this), "shouldDisplayProducts", function () {
      return _this.displayProducts;
    });

    _defineProperty(_assertThisInitialized(_this), "isCategoryActive", function () {
      return _this.objectifiedParameters.category && _this.objectifiedParameters.category.length === 1;
    });

    _defineProperty(_assertThisInitialized(_this), "subCategoryDataAssetPath", function (categoriesData, subCategory) {
      var subCategoryData = categoriesData.subCategories.find(function (_subCategory) {
        return _subCategory.id === subCategory.id;
      });

      if (subCategoryData) {
        return subCategoryData.image.url;
      } else {
        return '';
      }
    });

    _defineProperty(_assertThisInitialized(_this), "subSubCategoryDataAssetPath", function (categoriesData, subSubCategory) {
      var subSubCategoryData = categoriesData.subSubCategories.find(function (_subSubCategory) {
        return _subSubCategory.id === subSubCategory.id;
      });

      if (subSubCategoryData) {
        return subSubCategoryData.image.url;
      } else {
        return '';
      }
    });

    _this.objectifiedParameters = objectifyParameters(_this.props.match.params);
    _this._isMounted = false;
    var _window$getFamily = window.getFamily,
        requestUrl = _window$getFamily.requestUrl,
        nonce = _window$getFamily.nonce;
    _this.getFamilyNonce = nonce;
    _this.getFamilyUrl = requestUrl;
    _this.state = {
      activeBackDrop: false,
      activeProduct: {},
      products: [],
      categories: [],
      categoriesData: {},
      categoriesLoaded: false,
      certifications: [],
      families: [],
      family: null,
      pagination: {},
      loadingProduct: true,
      search: null,
      shopType: Object.keys(_this.objectifiedParameters)[0]
    };
    _this.displayProducts = _this.objectifiedParameters.category && _this.objectifiedParameters.category.length > 0 || Object.keys(_this.objectifiedParameters)[0] !== 'category';
    _this.displaySubSubCategories = _this.objectifiedParameters.category && _this.objectifiedParameters.category.length <= 2;
    return _this;
  }

  _createClass(ShopPage, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.querySelector('.shop-root').classList.add('shop');
      this.fetchProducts();
      this.fetchCategories();
      this.fetchCertifications();
      this.fetchFamilies();
      this.fetchFamily();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      this._isMounted = true;

      if (prevProps.match.params !== this.props.match.params) {
        this.objectifiedParameters = objectifyParameters(this.props.match.params);
        this.setState({
          shopType: Object.keys(this.objectifiedParameters)[0]
        });
        this.displayProducts = this.objectifiedParameters.category && this.objectifiedParameters.category.length > 0 || Object.keys(this.objectifiedParameters)[0] !== 'category';
        this.displaySubSubCategories = this.objectifiedParameters.category && this.objectifiedParameters.category.length <= 2;
        this.fetchProducts();
        this.fetchCertifications();
        this.fetchFamilies();
        this.fetchFamily();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
      document.querySelector('.shop-root').classList.remove('shop');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          activeBackDrop = _this$state.activeBackDrop,
          activeProduct = _this$state.activeProduct,
          activeSubSubCategoryName = _this$state.activeSubSubCategoryName,
          categories = _this$state.categories,
          categoriesData = _this$state.categoriesData,
          categoriesLoaded = _this$state.categoriesLoaded,
          certifications = _this$state.certifications,
          families = _this$state.families,
          family = _this$state.family,
          loadingProduct = _this$state.loadingProduct,
          pagination = _this$state.pagination,
          products = _this$state.products,
          search = _this$state.search,
          shopType = _this$state.shopType;
      return /*#__PURE__*/React.createElement("div", {
        className: "shop ".concat(products.length === 0 ? "empty-shop" : "")
      }, !loadingProduct && categoriesLoaded ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ShopMetaTags, null), /*#__PURE__*/React.createElement(AddCartModal, {
        product: activeProduct,
        activeBackDrop: activeBackDrop,
        closeModal: this.closeModal,
        closeModalOut: this.closeModalOut
      }), this.state.activeBackDrop === true ? /*#__PURE__*/React.createElement("div", {
        className: "backdrop",
        id: "BackDrop",
        onClick: this.closeModalOut
      }) : null, /*#__PURE__*/React.createElement("div", {
        className: "breadcrumbs-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "container"
      }, shopType === "category" ? /*#__PURE__*/React.createElement(BreadCrumbShop, {
        categories: categories,
        loadingProduct: loadingProduct,
        objectifiedParameters: this.objectifiedParameters,
        shopType: shopType,
        family: family
      }) : shopType === "certifications" && certifications.length ? /*#__PURE__*/React.createElement(BreadCrumbShop, {
        categories: categories,
        certifications: certifications,
        loadingProduct: loadingProduct,
        objectifiedParameters: this.objectifiedParameters,
        shopType: shopType,
        family: family
      }) : shopType === "search" ? /*#__PURE__*/React.createElement(BreadCrumbShop, {
        categories: categories,
        loadingProduct: loadingProduct,
        objectifiedParameters: this.objectifiedParameters,
        search: search,
        shopType: shopType,
        family: family
      }) : shopType === "families" ? /*#__PURE__*/React.createElement(BreadCrumbShop, {
        categories: categories,
        loadingProduct: loadingProduct,
        objectifiedParameters: this.objectifiedParameters,
        search: search,
        shopType: shopType,
        family: family
      }) : null)), family && /*#__PURE__*/React.createElement("div", {
        className: "home-head"
      }, /*#__PURE__*/React.createElement("div", {
        id: "carousel",
        className: "carousel carousel--banner slide carousel-fade",
        "data-banner": "1",
        "data-ride": "carousel",
        "data-interval": "6000",
        test: family.louis
      }, /*#__PURE__*/React.createElement("div", {
        className: " carousel-inner",
        role: "listbox"
      }, /*#__PURE__*/React.createElement("style", {
        type: "text/css"
      }, "[data-banner=\"1\"] .carousel-caption { min-height: ", family.bgRatio * 100, "vw; }", family.bgMobileRatio ? "@media (max-width: 575.98px) {\n                          [data-banner=\"1\"] .carousel-caption {\n                            min-height: ".concat(family.bgMobileRatio * 100, "vw;\n                          }\n                        }") : ''), /*#__PURE__*/React.createElement("div", {
        className: "carousel-item active"
      }, /*#__PURE__*/React.createElement("div", null, family.image_header_mobile && family.image_header ? /*#__PURE__*/React.createElement("picture", null, /*#__PURE__*/React.createElement("img", {
        srcSet: family.image_header,
        alt: "responsive image",
        className: "d-none d-sm-block img-fluid"
      }), /*#__PURE__*/React.createElement("img", {
        srcSet: family.image_header_mobile,
        alt: "responsive image",
        className: "d-sm-none img-fluid"
      })) : /*#__PURE__*/React.createElement("picture", null, /*#__PURE__*/React.createElement("img", {
        srcSet: family.image_header,
        alt: "responsive image",
        className: "d-block img-fluid"
      })), /*#__PURE__*/React.createElement("div", {
        className: "carousel-caption container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "content-caption position-relative"
      }, /*#__PURE__*/React.createElement("img", {
        srcSet: this.state.family.logo ? this.state.family.logo : '',
        alt: "responsive image",
        className: "d-block img-fluid"
      }), /*#__PURE__*/React.createElement("p", {
        className: "m-0"
      }, this.state.family.long_description)))))))), /*#__PURE__*/React.createElement("div", {
        className: "container mt-5"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 col-md-4 sidebar-container main-bg-after d-none d-sm-none d-md-block"
      }, /*#__PURE__*/React.createElement(Sidebar, {
        categories: categories,
        certifications: certifications,
        families: families,
        loadingProduct: loadingProduct,
        shopType: shopType
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-12 col-md-8 main-item-container"
      }, products.length > 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ShopHeaderFilters, {
        activeSubSubCategoryName: activeSubSubCategoryName,
        pagination: pagination
      }), /*#__PURE__*/React.createElement("div", {
        className: "row products-container"
      }, categories[0] !== undefined ? this.isCategoryActive() ? this.orderByName(categories[0].sub_categories).map(function (subCategory) {
        return /*#__PURE__*/React.createElement(SingleCategoryItem, {
          key: subCategory.id,
          link: getNewURL(_this2.objectifiedParameters, "category", _this2.getSubSubCategoryString(categories[0].id, subCategory.id), true),
          image: assetPath(_this2.subCategoryDataAssetPath(categoriesData, subCategory)),
          name: subCategory[translateFieldName("name")]
        });
      }) : this.displaySubSubCategories && this.orderByName(categories[0].sub_categories[0].sub_sub_categories).map(function (subSubCategory) {
        return /*#__PURE__*/React.createElement(SingleCategoryItem, {
          key: subSubCategory.id,
          link: getNewURL(_this2.objectifiedParameters, "category", _this2.getSubSubCategoryString(categories[0].id, categories[0].sub_categories[0].id, subSubCategory.id), true),
          image: assetPath(_this2.subSubCategoryDataAssetPath(categoriesData, subSubCategory)),
          name: subSubCategory[translateFieldName("name")]
        });
      }) : /*#__PURE__*/React.createElement(Redirect, {
        to: "/404"
      })), /*#__PURE__*/React.createElement("div", {
        className: "row products-container"
      }, products.map(function (product) {
        return /*#__PURE__*/React.createElement(SingleItem, {
          isShop: true,
          key: product.id,
          product: product,
          setActiveProduct: _this2.setActiveProduct
        });
      })), /*#__PURE__*/React.createElement(Pagination, {
        pagination: pagination
      })) : /*#__PURE__*/React.createElement("div", {
        className: "container mt-5"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 submitted"
      }, /*#__PURE__*/React.createElement("span", null, translate("NO RESULT FOUND", "AUCUN RESULTAT")), /*#__PURE__*/React.createElement("div", {
        className: "icon"
      }, /*#__PURE__*/React.createElement("img", {
        src: this.getResultIcon(),
        alt: ""
      })), /*#__PURE__*/React.createElement("a", {
        href: "/".concat(LANG, "/shop/#/page/categories")
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-dark"
      }, translate("RETURN TO CATEGORIES", "RETOUR AUX CATEGORIES"))))))))) : /*#__PURE__*/React.createElement("div", {
        className: "col-12 text-center loading"
      }, /*#__PURE__*/React.createElement(Loader, null)));
    }
  }]);

  return ShopPage;
}(Component);

ShopPage.propTypes = {
  history: PropTypes.object,
  match: PropTypes.object
};
export default ShopPage;